module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAGKkwY+AAAABGdBTUEAALGPC/xhBQAAAGxJREFUKBVj+P//vxkDHgCUT8SUBoqKwEWBHBUwB8h4wgAmYHJATiJcGiYIozEk0bU2wFTCaaCKp3AOjEFYEKgiCYjhrsTBQTIQ5OqncC0wCWw0UBENFANNBTnyCVYnUCRpDtTdAMSI+EPzFQAMWZAQAYdiRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/views/right-arrow.png
// module id = 399
// module chunks = 0